module.exports = __webpack_public_path__ + "img/redtiger.9a1f2a1f.svg";